import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import TitleComponent from "../../../components/widgets/titleComponent";
import HomeServiceBox from '../../homeSection/services/homeServiceBox';
import VisionIcon from '../../../assets/icons/vision.svg';
import MissionIcon from '../../../assets/icons/mission.svg';

const VisionNMissionLayout = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

    return (
        <>
            <Box 
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.paper,
                    py: {xs: 5, md: 10}
                }}
            >
                <Grid
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    container
                    width='100%'
                    px='5%'
                    spacing={{xs: 4, md: 0}}
                >
                    <Grid size={12}>
                        <TitleComponent 
                            title={t('about.visionNmission.title')}
                            description={isMdUp ? t('about.visionNmission.description') : ""}
                            removePadding={!isMdUp}
                            centerMode
                        />
                    </Grid>

                    <Grid
                        direction='row'
                        justifyContent='center'
                        alignItems='center'
                        width='100%'
                        container
                        spacing={{xs: 4, md: 10}}
                    >
                        <Grid size={{xs: 12, lg: 6}} data-aos="zoom-in">
                            <HomeServiceBox 
                                icon={VisionIcon}
                                title={t('about.visionNmission.vision.title')}
                                description={t('about.visionNmission.vision.description')}
                            />
                        </Grid>

                        <Grid size={{xs: 12, lg: 6}} data-aos="zoom-in">
                            <HomeServiceBox 
                                icon={MissionIcon}
                                title={t('about.visionNmission.mission.title')}
                                description={t('about.visionNmission.mission.description')}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default VisionNMissionLayout;